var map = {
	"./01.jpg": 1395,
	"./02.jpg": 5172,
	"./03.jpg": 8769,
	"./04.jpg": 1522,
	"./05.jpg": 1551,
	"./06.jpg": 1232,
	"./07.jpg": 9325,
	"./08.jpg": 2734,
	"./09.jpg": 2891,
	"./10.jpg": 9229,
	"./11.jpg": 4336,
	"./3d-design.jpg": 5599,
	"./application.jpg": 3014,
	"./css.jpg": 8777,
	"./ebooks.png": 1335,
	"./graphic-design.png": 7573,
	"./html.png": 529,
	"./lecture-video-recorder.jpg": 1645,
	"./logo.jpg": 1511,
	"./main.jpg": 4589,
	"./php.png": 2576,
	"./web-dev.jpg": 3780,
	"./web-element.jpg": 5053,
	"./wordpress.jpg": 9329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3064;